///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../common/data-template-base.ts"/>
///<reference path="../collections/client-type.collection.ts"/>
///<reference path="../filter-templates/active-inactive.filter.ts"/>

module Meevo.Components.Controls.SmartMover {
    import Dictionary = _.Dictionary;
    import ServiceCategory = Model.ServiceCategory;

    export class AlertsManagerServiceWithCategoriesTemplate extends DataTemplateBase implements IDataTemplate {
        public title: string;
        public allSelectedLabel: string;
        public totalSelectedMessage: string;

        private readonly _services: CollectionOptimizedApi<Model.Variant>;
        private readonly _serviceCategories: CollectionOptimizedApi<ServiceCategory>;

        get collection() {
            return this._serviceCategories;
        }

        get leafCollection() {
            return this._services;
        }

        get totalSelectedCount(): number {
            return this._services.value.length;
        }
        constructor(model: Dictionary<any>, properties: string[], options: IDataTemplateOptions) {
            super(model, properties, options.criteria);

            this._services = new CollectionOptimizedApi(this.model[properties[0]], [], {
                url: 'Service',
                smartMoverHidden: () => this.smartMoverHidden,
            }, options.$scope);

            this._serviceCategories = new CollectionOptimizedApi(this.model[properties[1]], [], {
                CategoryModel: VirtualRepeatCategory,
                url: 'serviceCategory',
                smartMoverHidden: () => this.smartMoverHidden,
            }, options.$scope);

            this._services.setParentCollection(this._serviceCategories, CoreServiceToCategoryStrategy);

            this.title = 'SERVICES';
            this.allSelectedLabel = 'LABEL_ALL_SERVICES';
            this.totalSelectedMessage = 'LABEL_TOTAL_SERVICES_SELECTED';
            this.filters = [
                new ActiveInactiveFilter({hideInactiveLabel: 'LABEL_HIDE_INACTIVE_SERVICES'}, this)
            ];

            this._services.addFilters(...this.filters as IInteractiveFilter[]);

            if (options.required) {
                this.validation.push(new RequiredValidation(this._services, 'LABEL_SERVICE_REQUIRED'));
            }
        }

        setWatchers(scope: angular.IScope) {
            this._serviceCategories.setWatchers(scope);
            this.collection.onModelValueChanged();

            super.setWatchers(scope);
        }
    }
}